import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import isElectron from 'is-electron';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import CookieConsent from 'react-cookie-consent';
import randomString from 'random-string';

import {
	Dialog,
	DialogContentText,
	DialogTitle as MuiDialogTitle,
	DialogContent as MuiDialogContent,
	DialogActions as MuiDialogActions
} from '@material-ui/core';

import {
	Typography,
	Button,
	TextField,
	Grid,
	FormGroup,
	FormControlLabel,
	Checkbox,
	Tooltip,
	IconButton,
	Avatar
} from '@material-ui/core';

import {
	Settings as SettingsIcon,
	ExitToApp as ExitToAppIcon,
	Info as InfoIcon
} from '@material-ui/icons';

import Alert from '@material-ui/lab/Alert';

import Settings from './Settings/Settings';

import Notifications from './Notifications/Notifications';
import * as settingsActions from '../actions/settingsActions';
import * as meActions from '../actions/meActions';
import * as roomActions from '../actions/roomActions';
import * as requestActions from '../actions/requestActions';

import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';

import { withRoomContext } from '../RoomContext';
import { wrapperAxios, getErrMesage } from '../utils';

import edition from '../version';

import Logger from '../Logger';

const logger = new Logger('ChooseRoom');

const styles = (theme) => ({
	root :
	{
		display              : 'flex',
		width                : '100%',
		height               : '100%',
		backgroundColor      : 'var(--background-color)',
		backgroundImage      : `url(${window.app_base_path}/svg/background.svg)`,
		backgroundAttachment : 'fixed',
		backgroundPosition   : 'center',
		backgroundSize       : 'cover',
		backgroundRepeat     : 'no-repeat',
		alignItems           : 'center',
		justifyContent       : 'center'
	},
	dialogTitle :
	{
	},
	dialogPaper :
	{
		width                          : '30vw',
		padding                        : theme.spacing(2),
		[theme.breakpoints.down('lg')] :
		{
			width : '40vw'
		},
		[theme.breakpoints.down('md')] :
		{
			width : '50vw'
		},
		[theme.breakpoints.down('sm')] :
		{
			width : '70vw'
		},
		[theme.breakpoints.down('xs')] :
		{
			width : '90vw'
		}
	},
	alertMessage : {
		display     : 'flex',
		alignItems  : 'center'
	},
	iconBtn : {
		padding     : theme.spacing(1)
	},
	logo :
	{
		display       : 'block',
		paddingBottom : '1vh'
	},
	loginButton :
	{
		position : 'absolute',
		right    : theme.spacing(2),
		top      : theme.spacing(2),
		padding  : 0
	},
	largeIcon :
	{
		fontSize : '2em'
	},
	largeAvatar :
	{
		width  : 50,
		height : 50
	},
	green :
	{
		color : 'rgba(0, 153, 0, 1)'
	},
	red :
	{
		color : 'rgba(153, 0, 0, 1)'
	},
	version : {
		fontSize : '0.8rem',
		flexGrow : 1
	}
});

const DialogTitle = withStyles((theme) => ({
	root :
	{
		margin  : 0,
		padding : theme.spacing(1)
	}
}))(MuiDialogTitle);

const DialogContent = withStyles((theme) => ({
	root :
	{
		padding : theme.spacing(2)
	}
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
	root :
	{
		margin  : 0,
		padding : theme.spacing(1)
	}
}))(MuiDialogActions);

const ChooseRoom = ({
	classes,
	roomClient,
	myPicture,

	settingsOpen,
	joining,
	joinError,
	joined,
	confId,

	resolution,
	mediaPerms,
	setMediaPerms,
	setAudioMuted,
	setVideoMuted,
	userInfo,
	setJoinError,
	setSettingsOpen,
	setUserInfo,
	loggedIn,
	setLoggedIn,
	setJoining,
	setConfId,
	changeDisplayName,
	showNotifications,
	notify,
	location,
	lang
}) => {

	// logger.debug('history 传进来的参数:', location);

	const intl = useIntl();
	const history = useHistory();
	const { register, handleSubmit, errors } = useForm();

	const _confIdRequired = (location && location.params && location.params.hasOwnProperty('confIdRequired')) ? location.params.confIdRequired : true;
	const _confPwdRequired = (location && location.params && location.params.hasOwnProperty('confPwdRequired')) ? location.params.confPwdRequired : false;

	const [messageTip, setMessageTip] = useState('');                            // 提示信息
	const [confIdRequired, setConfIdRequired] = useState(_confIdRequired);       // 显示会议号输入框(默认显示)
	const [confPwdRequired, setConfPwdRequired] = useState(_confPwdRequired);    // 显示会议密码输入框(默认隐藏)
	const [clickInProgress, setClickInProgress] = useState(false);               // 请求状态
	const [autoLoggingIn, setAutoLoggingIn] = useState(false);                   // 自动登录状态

	const [open, setOpen] = React.useState(false);

	const timeoutRef = useRef(null);
	const refSubmit = useRef();

	const _askForPerms = async () => {

		let _constraints = { audio: true };
		Object.assign(_constraints, { video: window.config.VIDEO_CONSTRAINS[resolution] });
		try {
			const stream = await navigator.mediaDevices.getUserMedia(_constraints);
			// 关闭stream
			stream.getTracks().forEach(track => track.stop());
		} catch (e) {
			logger.error('_askForPerms 出错:%o', e);
		}
	};

	const _timeoutAlert = () => {

		if (userInfo && userInfo.joinType === 1) {

			if(timeoutRef.current) {
				
				clearTimeout(timeoutRef.current)
			}

			const _loginTimeout = window.config.loginTimeout || (5 * 60 * 1000) ;

			const _timer = setTimeout(() => {

				logger.debug(`已经超时了...settingsOpen: ${settingsOpen}`)
				// 如果配置界面打开了,则需要关闭
				setSettingsOpen(false)
				setOpen(true);

			}, _loginTimeout);

			timeoutRef.current = _timer;
		}
	};

	useEffect(() => {

		const storage = window.sessionStorage;

		const _forceReload = storage['forceReload'];
		if (window.config.reloadEnabled && _forceReload === '1') {

			storage.removeItem('forceReload');
			window.location.reload(true);
		}

		setTimeout(() => {

			const msgId = storage['msgId'];
			if (msgId) {
				notify('info', intl.formatMessage({
					id             : msgId
				}));
				storage.removeItem('msgId');
			}
		}, 2000);

		logger.debug('参数信息', userInfo);

		window.addEventListener('mousemove', _timeoutAlert);

		if ((userInfo.joinType === 2 && userInfo.autoJoin === 0) || (userInfo.autoJoin === -1 && [1, 2].includes(userInfo.joinType) && userInfo.confId)) {

			setConfId(userInfo.confId);

			let _roomPwd = '';
			userInfo.confPwd && (_roomPwd = userInfo.confPwd);

			/**
			 * 自动登录
			 * @param {token} token
			 * @param {会议号} thirdConfId
			*/
			const _autoJoining = async (token, thirdConfId) => {

				setAutoLoggingIn(true);

				const _data = { token, thirdConfId };
				// 返回 token confId hasPwd
				const _roomInfo = await wrapperAxios.post('/conference/haspwd', _data);
				logger.debug('token 自动登录 /conference/haspwd 接口 参数:[%o] 返回[%o]', _data, _roomInfo);

				// 清理水印
				window.sessionStorage.removeItem('watermark');

				if (_roomInfo.isSuccess) {

					if (userInfo.nickname) {
						changeDisplayName(userInfo.nickname);
					} else {
						changeDisplayName(`Guest_${Math.floor(Math.random() * (100000 - 10000)) + 10000}`);
					}

					const _hasPwd = _roomInfo.hasPwd === 1 ? true : false;

					if (_hasPwd && !_roomPwd) {

						// 如果会议室需要密码但没有提供密码,则需要弹出密码输入框
						setUserInfo({ ...userInfo, autoJoin: -1 });

						setJoining(false);
						setAutoLoggingIn(false);

						setConfIdRequired(!_hasPwd);   // 隐藏会议号输入框
						setConfPwdRequired(_hasPwd);   // 显示密码输入框
					} else {

						setAudioMuted(!mediaPerms.audio);
						setVideoMuted(!mediaPerms.video);
						_askForPerms();

						await roomClient.join({
							roomId      : encodeURIComponent(userInfo.confId),
							joinVideo   : mediaPerms.video,
							joinAudio   : mediaPerms.audio,
							joinToken   : userInfo.token,
							roomPwd     : _hasPwd ? _roomPwd : '',
							joinType    : userInfo.joinType
						});
					}
				} else if (_roomInfo.errorCode === 0x020400 || _roomInfo.errorCode === 0x020407) {
						// 弹出会议室输入框
						setUserInfo({ ...userInfo, autoJoin: -1 });

						setJoining(false);
						setAutoLoggingIn(false);

						setConfIdRequired(true);     // 显示会议号输入框
						setConfPwdRequired(false);   // 隐藏密码输入框
				} else {

					setJoining(false);

					// 如果haspwd接口请求失败,则跳转到login界面
					const _errCode = parseInt(_roomInfo.errorCode);
					const _errMsg = getErrMesage(_errCode, lang);
					logger.debug(`${_errMsg}(${_errCode}) 跳转至 /login`);

					history.push(`/login`);
				}
			};

			// 新增逻辑
			if (!joining) {
				// 代表是登录中...
				setJoining(true);
				_autoJoining(userInfo.token, userInfo.confId);
			}

		} else if (!loggedIn) {

			const _redirectUrl = (userInfo && userInfo.path) ? userInfo.path : 'login';
			history.push(_redirectUrl);
		}

		return () => {

			window.removeEventListener('mousemove', _timeoutAlert)
			clearTimeout(timeoutRef.current)
		};

	}, []);

	useEffect(() => {

		if (errors.roomId) {
			setMessageTip(intl.formatMessage({
				id             : 'feedback.confNameRequired',
				defaultMessage : 'The conference number cannot be empty and must be of numeric type'
			}));
		}
		if(errors.confPwd) {
			setMessageTip(intl.formatMessage({
				id             : 'feedback.confPwdRequired',
				defaultMessage : 'The conference password cannot be empty'
			}));
		}

		refSubmit.current && refSubmit.current.focus();

	}, [errors]);

	useEffect(() => {

		if (joined) {

			setClickInProgress(false);
			setLoggedIn(true);
			history.push(`/`);

		} else if (joinError && joinError.hasError) {
			setAutoLoggingIn(false);

			const _errCode = parseInt(joinError.errorCode);
			const _errMsg = getErrMesage(_errCode, lang);
			setMessageTip(_errMsg);

			setClickInProgress(false);

			// 重新生成 peerId
			const _peerId = randomString({ length: 8 }).toLowerCase();

			roomClient.changePeerId(_peerId);

		}
	}, [history, setLoggedIn, joined, joinError])

	/**
	 * 加入会议(被joinRoom调用)
	 * @param {*} roomId
	 * @param {*} roomPwd
	 */
	const joinRoom = async (roomId, roomPwd) => {

		logger.debug('加入会议 joinRoom [roomId:%s, roomPwd:%s, userInfo:%o]', roomId, roomPwd, userInfo);

		if(userInfo.nickname) {

			changeDisplayName(userInfo.nickname);
		} else {

			changeDisplayName(`Guest_${Math.floor(Math.random() * (100000 - 10000)) + 10000}`);
		}

		setAudioMuted(!mediaPerms.audio);
		setVideoMuted(!mediaPerms.video);

		await _askForPerms();

		await roomClient.join({
			roomId      : encodeURIComponent(roomId),
			joinVideo   : mediaPerms.video,
			joinAudio   : mediaPerms.audio,
			joinToken   : userInfo.token,
			roomPwd     : roomPwd,
			joinType    : userInfo.joinType
		});
	}

	const handleLogin = async data => {

		logger.debug('登录参数 ', data, confId, userInfo);

		setClickInProgress(true);

		if(confIdRequired) {             // 会议号输入框
			const _confId = data.roomId ? data.roomId : confId;
			// 验证房间是否需要密码
			const _data = {
				token : userInfo.token,
				thirdConfId : _confId
			};
			const _roomInfo = await wrapperAxios.post('/conference/haspwd', _data);
			logger.debug(' 会议号登录 /conference/haspwd 接口 参数:[%o] 返回[%o]', _data, _roomInfo);
			if (_roomInfo.isSuccess) {

				const _hasPwd = _roomInfo.hasPwd === 1 ? true : false;
				if(_hasPwd) {

					setConfPwdRequired(_hasPwd);
					setConfIdRequired(!_hasPwd);

					setClickInProgress(false);
				} else {
					await joinRoom(_confId);
				}
			} else {
				const _errCode = parseInt(_roomInfo.errorCode);
				// 提示错误信息
				const _errMsg = getErrMesage(_errCode, lang);
				setMessageTip(_errMsg);

				setClickInProgress(false);
			}
		} else if(confPwdRequired) {     // 密码输入框

			const _confId = confId;
			const _roomPwd = data.confPwd;

			if(_confId && _roomPwd) {

				await joinRoom(_confId, _roomPwd);

			} else if(userInfo.joinType === 0 && userInfo.code) {

				await roomClient.join({
					roomId     : encodeURIComponent(userInfo.code),
					joinVideo  : mediaPerms.video,
					joinAudio  : mediaPerms.audio,
					roomPwd    : _roomPwd
				});
			}
		}
        // 等待服务器端事件返回
		// setClickInProgress(false);
	}

	const onMuteAudioChange = (event) => {

		setMediaPerms({ ...mediaPerms, audio: !event.target.checked });
	}

	const onMuteVideoChange = (event) => {

		setMediaPerms({ ...mediaPerms, video: !event.target.checked });
	}

	const handleClose = () => {

		setOpen(false);
		setUserInfo({});
		setLoggedIn(false);

		setJoinError({hasError: false, errorCode: ''});
		setConfId('');  // 清空会议号
		// 清理水印
		window.sessionStorage.removeItem('watermark');

		// 成功登录后长时间未入会则跳转至登录界面
		history.push(`/login`);
	};

	return (
		<div className={classes.root}>
			{ showNotifications &&
				<Notifications />
			}

			{(autoLoggingIn || joining) ?  <ReactLoading type='bars'/> : <Dialog
				open
				classes={{
					paper : classes.dialogPaper
				}}
			>

				<DialogTitle disableTypography className={classes.dialogTitle}>
					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item>
							{ window.config.logo !=='' ? <img alt='Logo' src={window.config.logo} /> : <Typography variant='h5'> {window.config.title} </Typography> }
						</Grid>

						<Grid item>
							<Tooltip
								arrow
								title={intl.formatMessage({
									id             : 'settings.settings',
									defaultMessage : 'Settings'
								})}
								placement='top-end'
							>
								<IconButton
									classes={{root: classes.iconBtn}}
									onClick={() => {

											setSettingsOpen(!settingsOpen);
										}
									}
								>
									<SettingsIcon/>
								</IconButton>
							</Tooltip>

							{ window.config.loginEnabled &&
							<Tooltip
								arrow
								title={intl.formatMessage({
									id             : loggedIn ? 'label.logout' : 'label.login',
									defaultMessage : loggedIn ? 'Logout' : 'Login'
								})}
								placement='top-end'
							>
								<IconButton
									classes={{root: classes.iconBtn}}
									onClick={
										loggedIn ?
											() => {
												const _redirectUrl = (userInfo && userInfo.path) ? userInfo.path : 'login';

												setUserInfo({ account: userInfo.account });
												setLoggedIn(false);
												// 清理水印
												window.sessionStorage.removeItem('watermark');
												// 清空历史错误
												setJoinError({ hasError: false, errorCode: '' });
												history.push(_redirectUrl);
											} :
											() => roomClient.login()
									}
								>
									{ myPicture ?
										<Avatar src={myPicture} />
										:
										<ExitToAppIcon/>
									}
								</IconButton>
							</Tooltip>
							}

						</Grid>
					</Grid>
					<hr />
				</DialogTitle>

				<form onSubmit={handleSubmit(handleLogin)}>
					<DialogContent>
						<DialogContentText gutterBottom>
							{confIdRequired &&  <FormattedMessage
								id='room.chooseRoom'
								defaultMessage='Choose the name of the room you would like to join'
							/>}
							{confPwdRequired && <FormattedMessage
								id='room.roomPwd'
								defaultMessage='Enter the password of the meeting you want to join'
							/>}
						</DialogContentText>

						{confIdRequired && <TextField
							name='roomId'
							label={intl.formatMessage({
								id             : 'label.roomId',
								defaultMessage : 'Meeting ID'
							})}
							defaultValue={confId}
							variant='outlined'
							margin='normal'
							onChange={(event) =>
							{
								const { value } = event.target;
								setConfId(value);
							}}
							onFocus={(event) => {
								setMessageTip('')
							}}
							fullWidth
							inputRef={register({
								required: true,
								pattern: {
									value: /^\d{1,12}$/
								}
							})}
							error={Boolean(errors.roomId)}
							inputProps={{
								maxLength: 24
							}}
						/>}

						{confPwdRequired && <TextField
							id='confPwd'
							label={intl.formatMessage({
								id             : 'label.password',
								defaultMessage : 'Password'
							})}
							variant='outlined'
							margin='normal'
							name='confPwd'
							type='password'
							autoComplete=''
							fullWidth
							inputRef={register({
								required: true,
							})}
							onFocus={(event) => {
								setMessageTip('')
							}}
							error={Boolean(errors.confPwd)}
							inputProps={{
								maxLength: 24,
							}}
						/>}

						<FormGroup row>
							<FormControlLabel
								control={
								<Checkbox
									checked={!mediaPerms.audio}
									onChange={onMuteAudioChange}
									color="primary"
								/>}
								label={intl.formatMessage({
									id             : 'tooltip.muteAudio',
									defaultMessage : 'Mute Audio'
								})}
							/>
							<FormControlLabel
								control={
								<Checkbox
									checked={!mediaPerms.video}
									onChange={onMuteVideoChange}
									color="primary"
								/>}
								label={intl.formatMessage({
									id             : 'tooltip.muteVideo',
									defaultMessage : 'Mute Video'
								})}
							/>
						</FormGroup>

						{messageTip &&
						<DialogContentText className={classes.red} variant='body2' gutterBottom>
							{messageTip}
						</DialogContentText>}
					</DialogContent>

					<DialogActions>
						<div className={classes.version}>v {edition.version.substring(0, edition.version.length - 4) + (window.config.versionSuffix ? window.config.versionSuffix : '')}</div>
						<Button
							ref={refSubmit}
							disabled={clickInProgress}
							type='submit'
							variant='contained'
							color='secondary'
						>
							<FormattedMessage
								id='label.join'
								defaultMessage='Join meet'
							/>
						</Button>
					</DialogActions>
				</form>
				{ !isElectron() &&
					<CookieConsent buttonText={intl.formatMessage({
						id             : 'room.consentUnderstand',
						defaultMessage : 'I understand'
					})}
					>
						<FormattedMessage
							id='room.cookieConsent'
							defaultMessage='This website uses cookies to enhance the user experience'
						/>
					</CookieConsent>
				}
			</Dialog>}

			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				disableBackdropClick={true}
				disableEscapeKeyDown={true}
				maxWidth="xs"
				fullWidth={true}
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<Alert icon={<InfoIcon style={{ color: '#ffeb3b', fontSize: '3rem' }} />} color="#fff" className={classes.alertMessage}>
							{intl.formatMessage({
								id: 'feedback.waitTimeout',
								defaultMessage: 'No operation for a long time, please log in again'
							})}
						</Alert>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}
						variant='contained'
						color='secondary'
						autoFocus
					>
						<FormattedMessage
							id='label.login'
							defaultMessage='Login'
						/>
					</Button>
				</DialogActions>
			</Dialog>

			{ settingsOpen &&
				<Settings />
			}

		</div>
	);
};

ChooseRoom.defaultProps = {
	confIdRequired: true,
	confPwdRequired: false
}

ChooseRoom.propTypes =
{
	classes            : PropTypes.object.isRequired,
	showNotifications  : PropTypes.bool.isRequired,

	settingsOpen       : PropTypes.bool.isRequired,
	joining            : PropTypes.bool.isRequired,
	joinError          : PropTypes.object.isRequired,
	joined             : PropTypes.bool.isRequired,
	confId             : PropTypes.string.isRequired,

	mediaPerms         : PropTypes.object.isRequired,

	setMediaPerms      : PropTypes.func.isRequired,
	setAudioMuted      : PropTypes.func.isRequired,
	setVideoMuted      : PropTypes.func.isRequired,

	resolution         : PropTypes.string.isRequired,
	roomClient         : PropTypes.any.isRequired,
	changeDisplayName  : PropTypes.func.isRequired,
	myPicture          : PropTypes.string,

	setConfId          : PropTypes.func.isRequired,

	userInfo           : PropTypes.object.isRequired,
	setJoinError       : PropTypes.func.isRequired,
	setSettingsOpen    : PropTypes.func.isRequired,
	setUserInfo        : PropTypes.func.isRequired,
	loggedIn           : PropTypes.bool.isRequired,
	setLoggedIn        : PropTypes.func.isRequired,
	lang             : PropTypes.string.isRequired,
	setJoining         : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {

		settingsOpen      : state.room.settingsOpen,
		joining           : state.room.joining,
		joinError         : state.room.joinError,
		joined            : state.room.joined,
		confId            : state.room.confId,

		mediaPerms        : state.settings.mediaPerms,
		resolution        : state.settings.resolution,
		userInfo          : state.me.userInfo,
		loggedIn          : state.me.loggedIn,
		myPicture         : state.me.picture,
		showNotifications : state.settings.showNotifications,
		lang              : state.intl.lang,
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		changeDisplayName : (displayName) =>
		{
			dispatch(settingsActions.setDisplayName(displayName));
		},
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		setConfId: (confId) => {
			dispatch(roomActions.setConfId(confId));
		},
		setMediaPerms : (mediaPerms) =>
		{
			dispatch(settingsActions.setMediaPerms(mediaPerms));
		},
		setJoinError : (joinError) =>
		{
			dispatch(roomActions.setJoinError(joinError));
		},
		setSettingsOpen : (settingsOpen) =>
		{
			dispatch(roomActions.setSettingsOpen(settingsOpen));
		},
		setUserInfo : (userInfo) =>
		{
			dispatch(meActions.setUserInfo(userInfo));
		},
		setLoggedIn: (flag) => {
			dispatch(meActions.setLoggedIn(flag));
		},
		// 设置入会返回状态
		setJoining: (flag) => {
			dispatch(roomActions.setJoining(flag));
		},
		notify : (type, msg) =>
		{
			dispatch(requestActions.notify({
				type,
				text:msg
			}));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.settingsOpen === next.room.settingsOpen &&
				prev.room.joining === next.room.joining &&
				prev.room.joinError === next.room.joinError &&
				prev.room.joined === next.room.joined &&
				prev.room.confId === next.room.confId &&

				prev.settings.mediaPerms === next.settings.mediaPerms &&
				prev.me.userInfo === next.me.userInfo &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.settings.showNotifications === next.settings.showNotifications &&
				prev.intl.lang === next.intl.lang
			);
		}
	}
)(withStyles(styles)(ChooseRoom)));

